import { struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { CountryCode } from '../../../country/CountryCode';
import { Id as OrganizationId } from '../../../organization/Id';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
	countryCode: CountryCode,
	organizationId: OrganizationId,
});
